import React from "react";

const ClickupIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_501)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.05371 14.4753L5.61393 12.514C6.97414 14.2892 8.4193 15.1075 10.0279 15.1075C11.6279 15.1075 13.0322 14.2989 14.3311 12.5376L16.9279 14.4516C15.0537 16.9914 12.7247 18.3333 10.0279 18.3333C7.33973 18.3333 4.98812 17 3.05371 14.4753Z",
  fill: "url(#paint0_linear_368_501)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0193 5.95054L5.46229 9.87742L3.35583 7.43441L10.029 1.68387L16.6494 7.43871L14.5333 9.87312L10.0193 5.95054Z",
  fill: "url(#paint1_linear_368_501)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_368_501",
  x1: 3.05371,
  y1: 16.4717,
  x2: 16.9279,
  y2: 16.4717,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8930FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#49CCF9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_368_501",
  x1: 3.35583,
  y1: 7.2563,
  x2: 16.6494,
  y2: 7.2563,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF02F0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC800"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_501"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13.9785,
  height: 16.6667,
  fill: "white",
  transform: "translate(3.01074 1.66667)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ClickupIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;